import { format } from "date-fns";
import api from "../services/api";

interface IReportResponse {
    codeResult: string;
    data: any[];
}

export interface IAGentPerformanceParams {
    year: string;
    month: string;

}

export interface IAgentePerformanceResponse {
    ganhos: number;
    debitos: number;
    cadastros: number;
    conferidos: number;
    faltam: number;
    semVendas: number;
    devedores: number;
    perdidos: number;
    totalPerdidos: number;
}


class AgentPerformanceRepository {
    public async AgentPerformance({ year, month }: IAGentPerformanceParams): Promise<IAgentePerformanceResponse> {
        const initialDate = format(new Date(parseInt(year), parseInt(month) - 1, 1, 0, 0, 0), "yyyy-MM-dd HH:mm:ss");
        const endDate = format(new Date(parseInt(year), parseInt(month), 1, 0, 0, 0), "yyyy-MM-dd HH:mm:ss");

        const body = {
            "tables": ["Kit", "Conference", "Pedido"],
            "sql": [
                {
                    "coderesult": "Ganho",
                    "query": `SELECT SUM(comissaoRepresentante) AS Ganho 
                    FROM Conference 
                    WHERE data >= "${initialDate}" 
                    AND data < "${endDate}" 
                    AND conferenceType = 0`
                },
                {
                    "coderesult": "Debitos",
                    "query": `SELECT SUM(valorReceber - valorRecebido) AS Debitos 
                    FROM Conference 
                    WHERE data >= "${initialDate}" 
                    AND data < "${endDate}" 
                    AND conferenceType = 0`
                },
                {
                    "coderesult": "Cadastros",
                    "query": `SELECT COUNT(id) as Cadastros 
                    FROM Kit 
                    WHERE tipo = 0 
                    AND statusKit = 3
                    AND dataEntrega >= "${initialDate}" 
                    AND dataEntrega < "${endDate}"`
                },
                {
                    "coderesult": "Conferidos",
                    "query": `SELECT COUNT(id) as Conferidos 
                    FROM Conference 
                    WHERE conferenceType = 0 
                    AND data >= "${initialDate}" 
                    AND data < "${endDate}"`
                },
                {
                    "coderesult": "Faltam",
                    "query": `SELECT COUNT(Kit.id) as Faltam 
                    FROM Kit 
                    INNER JOIN Pedido 
                    ON Pedido.id = Kit.pedidoId 
                    WHERE Kit.statusKit = 3 
                    AND Pedido.acerto >= "${initialDate}" 
                    AND Pedido.acerto < "${endDate}"`
                },
                {
                    "coderesult": "SemVendas",
                    "query": `SELECT COUNT(Kit.id) as SemVendas 
                    FROM Kit 
                    INNER JOIN Conference 
                    ON Conference.kitId = Kit.id 
                    WHERE Conference.valorVendido = 0 
                    AND Conference.conferenceType = 0 
                    AND Conference.data >= "${initialDate}" 
                    AND Conference.data < "${endDate}"`
                },
                {
                    "coderesult": "Devedores",
                    "query": `SELECT COUNT(Kit.id) as Devedores 
                    FROM Kit 
                    INNER JOIN Conference 
                    ON Conference.kitId = Kit.id 
                    WHERE Kit.estado = 1  
                    AND Conference.conferenceType = 0 
                    AND Conference.data >= "${initialDate}" 
                    AND Conference.data < "${endDate}"`
                },
                {
                    "coderesult": "Perdidos",
                    "query": `SELECT COUNT(Kit.id) as Perdidos 
                    FROM Kit 
                    INNER JOIN Pedido 
                    ON Pedido.id = Kit.pedidoId 
                    WHERE Kit.estado = 2 
                    AND Pedido.acerto >= "${initialDate}" 
                    AND Pedido.acerto < "${endDate}"`
                },
                {
                    "coderesult": "TotalPerdidos",
                    "query": `SELECT SUM(valor) as TotalPerdidos 
                    FROM Kit 
                    INNER JOIN Pedido 
                    ON Pedido.id = Kit.pedidoId 
                    WHERE Kit.estado = 2 
                    AND Pedido.acerto >= "${initialDate}" 
                    AND Pedido.acerto < "${endDate}"`
                }
            ]
        };

        const response = await api.post<IReportResponse[]>("reports", body);
        console.log(response);
        return {
            ganhos: this.GetFromCodeResult(response.data, "Ganho")[0].Ganho,
            debitos: this.GetFromCodeResult(response.data, "Debitos")[0].Debitos,
            cadastros: this.GetFromCodeResult(response.data, "Cadastros")[0].Cadastros,
            conferidos: this.GetFromCodeResult(response.data, "Conferidos")[0].Conferidos,
            faltam: this.GetFromCodeResult(response.data, "Faltam")[0].Faltam,
            semVendas: this.GetFromCodeResult(response.data, "SemVendas")[0].SemVendas,
            devedores: this.GetFromCodeResult(response.data, "Devedores")[0].Devedores,
            perdidos: this.GetFromCodeResult(response.data, "Perdidos")[0].Perdidos,
            totalPerdidos: this.GetFromCodeResult(response.data, "TotalPerdidos")[0].TotalPerdidos,
        };

    }

    GetFromCodeResult(data: IReportResponse[], codeResult: string) {
        return data.find(result => result.codeResult === codeResult)?.data || [];
    }
}

const agentPerformanceRepository = new AgentPerformanceRepository();
export default agentPerformanceRepository;